import React from 'react';
import {
  Card,
  CardContent,
  Grid,
  Button,
  Typography,
  Box,
  TextField,
  Checkbox,
} from '@material-ui/core';
import {
  FilterList as FilterIcon,
  Clear as ClearIcon,
  Search as SearchIcon,
} from '@material-ui/icons';
import ReactSelect, { components } from 'react-select';
import { useStyles } from '../styles/PracticasConvenio.styles';

const coloresEstado = {
  aprobada: { color: '#2e7d32', background: '#f1f8f2', border: '#9ad59f' },
  pendiente: { color: '#8a5b00', background: '#fff8e1', border: '#f2cf6b' },
  correcciones: { color: '#b91c1c', background: '#fff1f1', border: '#f4a7a7' },
  proceso: { color: '#1976d2', background: '#eef6ff', border: '#9fc9f5' },
  modificaciones: { color: '#0277bd', background: '#eef8fc', border: '#91d5ef' },
  finalizada: { color: '#00695c', background: '#eef9f7', border: '#91d0c8' },
  archivada: { color: '#52525b', background: '#f7f7f8', border: '#d4d4d8' },
};

const estadosPractica = [
  { value: 'Cronograma en Proceso de creación', label: 'Cronograma en Proceso de creación', ...coloresEstado.proceso },
  { value: 'Práctica creada', label: 'Práctica creada', ...coloresEstado.proceso },
  { value: 'Práctica pendiente de aprobación por DNERHS', label: 'Práctica pendiente de aprobación por DNERHS', ...coloresEstado.pendiente },
  { value: 'Práctica con correcciones solicitadas por DNERHS', label: 'Práctica con correcciones solicitadas por DNERHS', ...coloresEstado.correcciones },
  { value: 'Práctica con modificaciones', label: 'Práctica con modificaciones', ...coloresEstado.modificaciones },
  { value: 'Práctica con modificaciones pendientes de aprobación por DNERHS', label: 'Práctica con modificaciones pendientes de aprobación por DNERHS', ...coloresEstado.pendiente },
  { value: 'Práctica con modificaciones aprobadas por DNERHS', label: 'Práctica con modificaciones aprobadas por DNERHS', ...coloresEstado.aprobada },
  { value: 'Práctica aprobada por DNERHS', label: 'Práctica aprobada por DNERHS', ...coloresEstado.aprobada },
  { value: 'Práctica cronograma finalizada', label: 'Práctica cronograma finalizada', ...coloresEstado.finalizada },
  { value: 'Práctica archivada', label: 'Práctica archivada', ...coloresEstado.archivada },
];

const opcionTodosEstados = {
  value: '__todos__',
  label: 'Todos los estados',
  color: '#334155',
  background: '#f8fafc',
  border: '#cbd5e1',
};

const FiltrosAvanzados = ({
  filtros,
  opciones,
  onFiltrosChange,
  onBuscar,
  onLimpiar,
  loading,
  loadingOpciones,
}) => {
  const classes = useStyles();

  const handleChange = (campo, valor) => {
    onFiltrosChange({
      ...filtros,
      [campo]: valor,
    });
  };

  const estadosSeleccionados = Array.isArray(filtros.estados)
    ? filtros.estados
    : filtros.estado && filtros.estado !== 'todos'
      ? [filtros.estado]
      : [];

  const hasPeriodo = Boolean(filtros.periodoDesde && filtros.periodoHasta);
  const menuPortalTarget = typeof document !== 'undefined' ? document.body : null;
  const estadosSelectValue = estadosPractica.filter((estado) => estadosSeleccionados.includes(estado.value));
  const opcionesEstado = [opcionTodosEstados, ...estadosPractica];

  const formatPeriodo = (value) => {
    if (!value) return '';
    const [anio, mes] = value.split('-');
    if (!anio || !mes) return value;

    const meses = [
      'ene',
      'feb',
      'mar',
      'abr',
      'may',
      'jun',
      'jul',
      'ago',
      'sep',
      'oct',
      'nov',
      'dic',
    ];

    return `${meses[Number(mes) - 1] || mes} ${anio}`;
  };

  const buildSelectOptions = (items, allValue, allLabel) => [
    { value: allValue, label: allLabel },
    ...(items || []).map((item) => ({ value: item, label: item })),
  ];

  const getSelectValue = (options, value, defaultValue) => {
    return options.find((option) => option.value === (value || defaultValue)) || options[0];
  };

  const searchableSelectStyles = {
    control: (base, state) => ({
      ...base,
      minHeight: 42,
      height: 42,
      borderColor: state.isFocused ? '#3f51b5' : '#c4c4c4',
      boxShadow: 'none',
      cursor: 'text',
      '&:hover': {
        borderColor: '#3f51b5',
      },
    }),
    valueContainer: (base) => ({
      ...base,
      height: 40,
      padding: '0 10px',
      overflow: 'hidden',
    }),
    input: (base) => ({
      ...base,
      margin: 0,
      padding: 0,
    }),
    singleValue: (base) => ({
      ...base,
      color: '#111827',
      fontSize: 14,
    }),
    indicatorsContainer: (base) => ({
      ...base,
      height: 40,
    }),
    menuPortal: (base) => ({
      ...base,
      zIndex: 9999,
    }),
    menu: (base) => ({
      ...base,
      zIndex: 9999,
    }),
    menuList: (base) => ({
      ...base,
      maxHeight: 280,
    }),
    option: (base, state) => ({
      ...base,
      backgroundColor: state.isFocused ? '#f8fafc' : '#fff',
      color: '#111827',
      cursor: 'pointer',
      fontSize: 13,
    }),
  };

  const SearchableFilterSelect = ({
    label,
    campo,
    value,
    options,
    defaultValue,
    disabled,
  }) => (
    <Box className={classes.searchableSelectField}>
      <Typography variant="caption" className={classes.multiSelectLabel}>
        {label}
      </Typography>
      <ReactSelect
        isSearchable
        isDisabled={disabled}
        options={options}
        value={getSelectValue(options, value, defaultValue)}
        onChange={(option) => handleChange(campo, option ? option.value : defaultValue)}
        styles={searchableSelectStyles}
        placeholder="Buscar..."
        noOptionsMessage={() => 'Sin resultados'}
        menuPortalTarget={menuPortalTarget}
        menuPosition="fixed"
        menuShouldScrollIntoView={false}
      />
    </Box>
  );

  const handleEstadosChange = (seleccion, actionMeta) => {
    const opcion = actionMeta && actionMeta.option;

    if (opcion && opcion.value === opcionTodosEstados.value) {
      handleChange('estados', []);
      return;
    }

    const nuevosEstados = (seleccion || [])
      .filter((estado) => estado.value !== opcionTodosEstados.value)
      .map((estado) => estado.value);

    handleChange('estados', nuevosEstados);
  };

  const removeEstado = (estadoValue) => {
    handleChange('estados', estadosSeleccionados.filter((estado) => estado !== estadoValue));
  };

  const activeFilters = [
    ...estadosSelectValue.map((estado) => ({
      key: `estado-${estado.value}`,
      label: estado.label,
      color: estado.color,
      background: estado.background,
      border: estado.border,
      onRemove: () => removeEstado(estado.value),
    })),
  ];

  if (filtros.periodoDesde || filtros.periodoHasta) {
    activeFilters.push({
      key: 'periodo',
      label: `Periodo: ${formatPeriodo(filtros.periodoDesde) || 'sin desde'} - ${formatPeriodo(filtros.periodoHasta) || 'sin hasta'}`,
      color: '#475569',
      background: '#f8fafc',
      border: '#cbd5e1',
      onRemove: () => onFiltrosChange({
        ...filtros,
        periodoDesde: '',
        periodoHasta: '',
      }),
    });
  }

  if (filtros.institucion && filtros.institucion !== 'todas') {
    activeFilters.push({
      key: 'institucion',
      label: `Institucion: ${filtros.institucion}`,
      color: '#334155',
      background: '#f8fafc',
      border: '#cbd5e1',
      onRemove: () => handleChange('institucion', 'todas'),
    });
  }

  if (filtros.carrera && filtros.carrera !== 'todas') {
    activeFilters.push({
      key: 'carrera',
      label: `Carrera: ${filtros.carrera}`,
      color: '#334155',
      background: '#f8fafc',
      border: '#cbd5e1',
      onRemove: () => handleChange('carrera', 'todas'),
    });
  }

  if (filtros.servicio && filtros.servicio !== 'todos') {
    activeFilters.push({
      key: 'servicio',
      label: `Servicio: ${filtros.servicio}`,
      color: '#334155',
      background: '#f8fafc',
      border: '#cbd5e1',
      onRemove: () => handleChange('servicio', 'todos'),
    });
  }

  if (filtros.ciEstudiante && filtros.ciEstudiante.trim() !== '') {
    activeFilters.push({
      key: 'ciEstudiante',
      label: `C.I.: ${filtros.ciEstudiante.trim()}`,
      color: '#334155',
      background: '#f8fafc',
      border: '#cbd5e1',
      onRemove: () => handleChange('ciEstudiante', ''),
    });
  }

  if (filtros.cronogramaId && filtros.cronogramaId.trim() !== '') {
    activeFilters.push({
      key: 'cronogramaId',
      label: `Cronograma: ${filtros.cronogramaId.trim()}`,
      color: '#334155',
      background: '#f8fafc',
      border: '#cbd5e1',
      onRemove: () => handleChange('cronogramaId', ''),
    });
  }

  const EstadoValueContainer = ({ children, ...props }) => {
    const cantidad = props.selectProps.estadosCount || 0;
    const texto = cantidad === 0
      ? 'Todos los estados'
      : cantidad === 1
        ? '1 estado seleccionado'
        : `${cantidad} estados seleccionados`;
    const childrenArray = React.Children.toArray(children);
    const input = childrenArray[childrenArray.length - 1];

    return (
      <components.ValueContainer {...props}>
        <Box component="span" className={classes.estadoSelectSummary}>
          {texto}
        </Box>
        {input}
      </components.ValueContainer>
    );
  };

  const EstadoOption = (props) => {
    const esTodos = props.data.value === opcionTodosEstados.value;
    const optionStyle = props.isSelected
      ? {
          backgroundColor: props.data.background,
          borderLeft: `3px solid ${props.data.color}`,
          fontWeight: 600,
        }
      : {};

    return (
      <components.Option {...props}>
        <Box
          display="flex"
          alignItems="center"
          style={{
            ...optionStyle,
            width: '100%',
            padding: '8px 12px',
          }}
        >
          <Checkbox
            size="small"
            color="primary"
            checked={esTodos ? estadosSeleccionados.length === 0 : props.isSelected}
            style={{ padding: 4, marginRight: 6 }}
          />
          <Box
            component="span"
            style={{
              width: 8,
              height: 8,
              borderRadius: '50%',
              backgroundColor: props.data.color,
              marginRight: 8,
              flex: '0 0 auto',
            }}
          />
          <span>{props.label}</span>
        </Box>
      </components.Option>
    );
  };

  const EstadoMenuList = (props) => (
    <components.MenuList {...props}>
      <Box className={classes.estadoMenuHeader} onMouseDown={(event) => event.preventDefault()}>
        <Typography variant="caption" className={classes.estadoMenuSearchHint}>
          Escriba para buscar estado...
        </Typography>
        <Box display="flex" alignItems="center" justifyContent="space-between" mt={1}>
          <Button
            size="small"
            color="primary"
            onClick={() => handleChange('estados', estadosPractica.map((estado) => estado.value))}
          >
            Seleccionar todos
          </Button>
          <Button
            size="small"
            onClick={() => handleChange('estados', [])}
          >
            Limpiar selección
          </Button>
        </Box>
      </Box>
      {props.children}
    </components.MenuList>
  );

  const estadoSelectStyles = {
    control: (base, state) => ({
      ...base,
      minHeight: 42,
      height: 42,
      borderColor: state.isFocused ? '#3f51b5' : '#c4c4c4',
      boxShadow: 'none',
      cursor: 'pointer',
      '&:hover': {
        borderColor: '#3f51b5',
      },
    }),
    valueContainer: (base) => ({
      ...base,
      height: 40,
      padding: '0 10px',
      overflow: 'hidden',
      flexWrap: 'nowrap',
    }),
    input: (base) => ({
      ...base,
      margin: 0,
      padding: 0,
    }),
    indicatorsContainer: (base) => ({
      ...base,
      height: 40,
    }),
    menuPortal: (base) => ({
      ...base,
      zIndex: 9999,
    }),
    menu: (base) => ({
      ...base,
      width: 360,
      zIndex: 9999,
    }),
    menuList: (base) => ({
      ...base,
      maxHeight: 320,
      paddingTop: 0,
    }),
    option: (base, state) => ({
      ...base,
      backgroundColor: state.isSelected ? state.data.background : state.isFocused ? '#f8fafc' : '#fff',
      color: '#111827',
      cursor: 'pointer',
      fontSize: 13,
      padding: 0,
    }),
  };

  const opcionesInstitucion = buildSelectOptions(opciones.instituciones, 'todas', 'Todas');
  const opcionesCarrera = buildSelectOptions(opciones.carreras, 'todas', 'Todas');
  const opcionesServicio = buildSelectOptions(opciones.servicios, 'todos', 'Todos');

  return (
    <Card className={classes.filtersCard}>
      <CardContent>
        <Box display="flex" alignItems="center" mb={2}>
          <FilterIcon color="primary" style={{ marginRight: 8 }} />
          <Typography variant="h6" color="primary">
            Filtros de consulta
          </Typography>
        </Box>

        <Grid container spacing={2} alignItems="center">
          <Grid item xs={12} sm={6} md={3}>
            <TextField
              fullWidth
              type="month"
              variant="outlined"
              size="small"
              label="Desde"
              value={filtros.periodoDesde || ''}
              onChange={(e) => handleChange('periodoDesde', e.target.value)}
              InputLabelProps={{ shrink: true }}
            />
          </Grid>

          <Grid item xs={12} sm={6} md={3}>
            <TextField
              fullWidth
              type="month"
              variant="outlined"
              size="small"
              label="Hasta"
              value={filtros.periodoHasta || ''}
              onChange={(e) => handleChange('periodoHasta', e.target.value)}
              InputLabelProps={{ shrink: true }}
            />
          </Grid>

          <Grid item xs={12} sm={6} md={3}>
            <SearchableFilterSelect
              label="Institucion"
              campo="institucion"
              value={filtros.institucion}
              options={opcionesInstitucion}
              defaultValue="todas"
              disabled={loadingOpciones}
            />
          </Grid>

          <Grid item xs={12} sm={6} md={3}>
            <SearchableFilterSelect
              label="Carrera"
              campo="carrera"
              value={filtros.carrera}
              options={opcionesCarrera}
              defaultValue="todas"
              disabled={loadingOpciones}
            />
          </Grid>
        </Grid>

        <Box className={classes.filtersSecondRow}>
          <Box className={classes.serviceFilterField}>
            <SearchableFilterSelect
              label="Servicio"
              campo="servicio"
              value={filtros.servicio}
              options={opcionesServicio}
              defaultValue="todos"
              disabled={loadingOpciones}
            />
          </Box>

          <TextField
            variant="outlined"
            size="small"
            label="C.I. estudiante"
            placeholder="Buscar por C.I."
            value={filtros.ciEstudiante || ''}
            onChange={(e) => handleChange('ciEstudiante', e.target.value)}
            className={classes.ciFilterField}
          />

          <TextField
            variant="outlined"
            size="small"
            label="Cronograma"
            placeholder="Ej. 14720"
            value={filtros.cronogramaId || ''}
            onChange={(e) => handleChange('cronogramaId', e.target.value)}
            className={classes.cronogramaFilterField}
          />

          <Box className={classes.multiSelectField}>
            <Typography variant="caption" className={classes.multiSelectLabel}>
              Estados
            </Typography>
            <ReactSelect
              isMulti
              closeMenuOnSelect={false}
              hideSelectedOptions={false}
              options={opcionesEstado}
              value={estadosSelectValue}
              onChange={handleEstadosChange}
              components={{
                Option: EstadoOption,
                MenuList: EstadoMenuList,
                ValueContainer: EstadoValueContainer,
              }}
              styles={estadoSelectStyles}
              placeholder=""
              noOptionsMessage={() => 'Sin estados'}
              isOptionSelected={(option) => estadosSeleccionados.includes(option.value)}
              menuPortalTarget={menuPortalTarget}
              menuPosition="fixed"
              menuShouldScrollIntoView={false}
              estadosCount={estadosSeleccionados.length}
            />
          </Box>

          <Box className={classes.queryActions}>
            <Button
              variant="contained"
              color="primary"
              startIcon={<SearchIcon />}
              onClick={onBuscar}
              disabled={loading}
            >
              Buscar
            </Button>
            <Button
              variant="outlined"
              startIcon={<ClearIcon />}
              onClick={onLimpiar}
              disabled={loading}
            >
              Limpiar
            </Button>
          </Box>
        </Box>

        {activeFilters.length > 0 && (
          <Box className={classes.estadosSeleccionadosPanel}>
            <Box className={classes.estadosSeleccionadosHeader}>
              <Typography variant="caption" className={classes.estadoSelectedTitle}>
                Filtros activos ({activeFilters.length})
              </Typography>
              <Button
                size="small"
                className={classes.limpiarEstadosButton}
                onClick={onLimpiar}
              >
                Limpiar filtros
              </Button>
            </Box>
            <Box className={classes.estadoSelectedChips}>
              {activeFilters.map((filter) => (
                <Box
                  key={filter.key}
                  className={classes.estadoSelectedChip}
                  style={{
                    backgroundColor: filter.background,
                    borderColor: filter.border,
                    color: filter.color,
                  }}
                >
                  <span className={classes.estadoSelectedDot} style={{ backgroundColor: filter.color }} />
                  <span>{filter.label}</span>
                  <button type="button" aria-label={`Quitar ${filter.label}`} onClick={filter.onRemove}>x</button>
                </Box>
              ))}
            </Box>
          </Box>
        )}

        {!hasPeriodo && (
          <Typography variant="caption" color="textSecondary" display="block" style={{ marginTop: 12 }}>
            Todos los filtros son opcionales. Puede buscar sin periodo o combinar C.I., estados, institucion, carrera, servicio y cronograma.
          </Typography>
        )}
      </CardContent>
    </Card>
  );
};

export default FiltrosAvanzados;
